import Prism from 'prismjs';
Prism.manual = true;

function highlightCode() {
    [...document.querySelectorAll('pre code')].forEach(el => {
        Prism.highlightElement(el);
    });
}

document.addEventListener('DOMContentLoaded', () => {
    if (document.querySelector('#docs')) {
        highlightCode();
    }
});
